export const SAVE_DATA_BOOKING = `BOOKING/SAVE_DATA`;
export const SAVE_DATA_BOOKING_REQUEST = `${SAVE_DATA_BOOKING}_REQUEST`;
export const SAVE_DATA_BOOKING_SUCCESS = `${SAVE_DATA_BOOKING}_SUCCESS`;
export const RESET_BOOKING_CONFIRM = `${SAVE_DATA_BOOKING}_RESET`;
